/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button } from "@mui/material";

const DialogActions = (props) => {
    
    const {
        handleSelectIcon,
        handleCancel,
    } = props;

    return (
        <Fragment>
            <div className="simplicity-document-selector-window-footer">
                
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSelectIcon}
                >
                    Select
                </Button>
                
                <Button
                    variant='outlined'
                    color='secondary'
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            
            </div>
        </Fragment>
    );
};

export { DialogActions };
